module.exports = __webpack_public_path__ + "img/ar.e57d35b4.png";